import React, { createContext, useContext, useCallback, useState } from 'react';

import SearchData from 'interfaces/SearchData';

interface SearchContextData {
  selectedSearch: SearchData | null;
  selectSearch(searchData: SearchData): void;
  clearSearch(): void;
}

const SearchContext = createContext<SearchContextData>({} as SearchContextData);

const SearchProvider: React.FC = ({ children }) => {
  const [selectedSearch, setSelectedSearch] = useState<SearchData | null>(
    () => {
      const search = localStorage.getItem('search');

      if (search) {
        return JSON.parse(search) as SearchData;
      }

      return null;
    },
  );

  const selectSearch = useCallback((search: SearchData) => {
    localStorage.setItem('search', JSON.stringify(search));

    setSelectedSearch(search);
  }, []);

  const clearSearch = useCallback(() => {
    localStorage.removeItem('search');

    setSelectedSearch(null);
  }, []);

  return (
    <SearchContext.Provider
      value={{ selectedSearch, selectSearch, clearSearch }}
    >
      {children}
    </SearchContext.Provider>
  );
};

/** Handles the search context */
function useSearch(): SearchContextData {
  const context = useContext(SearchContext);

  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }

  return context;
}

export { SearchProvider, useSearch };
